import React, { FunctionComponent, PropsWithChildren, ReactNode } from "react";
import { Helmet } from "react-helmet";
import { Spinner } from "react-bootstrap";

interface Props extends PropsWithChildren {
  /** Page title, rendered as the h1 in the sticky top bar. */
  title: string;
  /** Browser tab title. */
  siteTitle: string;
  /** Muted context line next to the title, e.g. "38 Einträge". */
  subtitle?: string;
  /** Page-level actions, right aligned in the top bar. */
  actions?: ReactNode;
  /** Constrains the content column — used by settings-style forms. */
  maxWidth?: number;
  isLoading?: boolean;
}

const renderLoading = (
  <div className="d-flex justify-content-center align-items-center py-5">
    <div className="text-center">
      <Spinner animation="border" size="sm" className="mb-3" style={{ color: "var(--accent)" }} />
      <p className="text-muted mb-0">Daten werden geladen...</p>
    </div>
  </div>
);

export const ContentLayout: FunctionComponent<Props> = ({
  title,
  siteTitle,
  subtitle,
  actions,
  maxWidth,
  isLoading,
  children
}) => {
  return (
    <>
      <Helmet>
        <title>{siteTitle}</title>
      </Helmet>
      <header className="page-header">
        <h1>{title}</h1>
        {subtitle && <span className="page-header__subtitle">{subtitle}</span>}
        {actions && <div className="page-header__actions">{actions}</div>}
      </header>
      <div className="page-body" style={maxWidth ? { maxWidth } : undefined}>
        {isLoading ? renderLoading : <div className="fade-in">{children}</div>}
      </div>
    </>
  );
};
